import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Server } from "http";
import { BehaviorSubject, EMPTY, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ContactFormRequest } from "src/app/model/contact-form-request";
import { NotificationSettingsRequest } from "src/app/model/user/notification-settings-request";
import { SignUpRequest } from "src/app/model/user/sign-up-request";
import { UploadRequest } from "src/app/model/user/upload-request";
import { User } from "src/app/model/user/user";
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";

@Injectable({
  providedIn: "root",
})
export class UserService implements Resolve<any> {
  constructor(private restApiService: RestApiService) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.getUser();
  }
  endpoint = "user/";
  user = new BehaviorSubject<User>(null);

  getUser() {
    return this.fetchUser().pipe(tap((user: User) => this.user.next(user)));
  }

  /* API CALLS */

  signUp = (signUpRequest: SignUpRequest) =>
    this.restApiService.post(
      ServerType.USER,
      this.endpoint + "sign-up",
      signUpRequest
    );

  updateUser = (user: User) =>
    this.restApiService.post(
      ServerType.USER,
      this.endpoint + "update-user",
      user
    );

  updateLanguage(language: string) {
    if (!this.user.value) return EMPTY;
    return this.updateUser({
      ...this.user.value,
      notificationLanguage: language.toUpperCase(),
    });
  }

  fetchUser = () =>
    this.restApiService.get(
      ServerType.USER,
      this.endpoint + "get-profile-with-files"
    );

  uploadFile = (uploadRequest: UploadRequest) =>
    this.restApiService.post(
      ServerType.USER,
      this.endpoint + "upload-file",
      uploadRequest.file,
      {
        params: {
          fileName: uploadRequest.fileName,
          fileType: uploadRequest.fileType,
        },
      }
    );

  getUserMail = (userId: string) =>
    this.restApiService.get(ServerType.USER, this.endpoint + `mail/${userId}`, {
      responseType: "text",
    });

  isExist = (userId: string) =>
    this.restApiService.get(
      ServerType.USER,
      this.endpoint + `is-exist/${userId}`
    );

  addShareHolder(shareholderName: string, file): Observable<any> {
    let params = new HttpParams();
    params = params.append("shareholderName", shareholderName);

    return this.restApiService.post(
      ServerType.USER,
      this.endpoint + "add-shareholder",
      file,
      { params }
    );
  }

  deleteShareholder(id): Observable<any> {
    return this.restApiService.get(
      ServerType.USER,
      this.endpoint + "delete-shareholder/" + id
    );
  }

  updateNotificationSettings(
    notificationSettings: NotificationSettingsRequest
  ) {
    return this.restApiService.post(
      ServerType.USER,
      this.endpoint + "update-notification-settings",
      notificationSettings
    );
  }

  sendContactRequest(contactFormRequest: ContactFormRequest) {
    return this.restApiService.post(
      ServerType.USER,
      "form/create",
      contactFormRequest
    );
  }
}
